import Error404 from "./404.react";

export {
  Error404
};



// WEBPACK FOOTER //
// ./src/errors/index.js